<template>
  <v-card
    class="payment-report mx-auto pa-2 overflow-visible"
    outlined
  >
    <v-list-item>
      <v-list-item-content class="overflow-visible">
        <v-list-item-title class="headline mb-2">
          Báo cáo doanh thu và đơn hàng theo hình thức thanh toán
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <v-row>
      <v-col cols="12" md="6">
        <v-list-item>
          <v-list-item-title class="headline mb-2 text-center">
            Doanh thu
          </v-list-item-title>
        </v-list-item>

        <div
          v-if="Object.keys(chartDataTurnOver).length"
        >
          <chartist
            ratio="ct-major-second"
            type="Pie"
            :data="chartDataTurnOver"
            :options="chartOptions"
          />

          <ul class="description">
            <li v-for="(item, index) in chartDataTurnOver.note" :key="index" class="d-inline-flex align-items-center">
              <v-avatar
                tile
                v-bind:style="{'background-color':chartDataTurnOver.color[index % 10]}"
                size="20"
                class="mx-1"
              />
              {{item}}
            </li>
          </ul>
        </div>

        <common-no-result
          v-if="!Object.keys(chartDataTurnOver).length"
        />
      </v-col>


      <!-- Quantities -->
      <v-col cols="12" md="6">
        <v-list-item>
          <v-list-item-title class="headline mb-2 text-center">
            Số đơn hàng
          </v-list-item-title>
        </v-list-item>

        <div
          v-if="Object.keys(chartDataQty).length"
        >
          <chartist
            ratio="ct-major-second"
            type="Pie"
            :data="chartDataQty"
            :options="chartOptions"
          />
          <ul class="description">
            <li v-for="(item, index) in chartDataQty.note" :key="index" class="d-inline-flex align-items-center">
              <v-avatar
                tile
                v-bind:style="{'background-color':chartDataQty.color[index % 10]}"
                size="20"
                class="mx-1"
              />
              {{item}}
            </li>
          </ul>
        </div>

        <common-no-result
          v-if="!Object.keys(chartDataQty).length"
        />
      </v-col>
    </v-row>

  </v-card>
</template>

<script>

import { colorChart } from '@/helpers/constants'
import * as moment from 'moment'
import * as ChartistTooltips from 'chartist-plugin-tooltips';

import RepositoryFactory from "@/repositories/RepositoryFactory";
const ReportRepository = RepositoryFactory.get('report');

export default {
  props: {
    filterForm: {
      default: () => ({})
    },
  },
  data () {
    return {
      chartDataTurnOver: {},
      chartDataQty: {},
      chartOptions: {
        height: 300,
        plugins: [this.$chartist.plugins.tooltip(
          {
            currency: ' ',
            // appendToBody: true
          }
        )],
      },
      color: colorChart,
    }
  },
  created() {
    this.fetchData()
    Bus.$on('payment-report', () => {
      this.fetchData()
    })
  },
  beforeDestroy() {
    Bus.$off('payment-report')
  },
  methods: {
    async fetchData() {
      const loader = this.$loading.show()
      const params = {
        startDateTime: moment(this.filterForm.dateRange.startDate).format('YYYY-MM-DD 00:00:00'),
        endDateTime: moment(this.filterForm.dateRange.endDate).format('YYYY-MM-DD 23:59:59'),
        schoolLevelId: this.$store.state.module.schoolLevelId,
        typeId: this.$store.state.module.typeId
      };
      const result = await ReportRepository.fetchPayment(params)
      loader.hide()

      if (result.success) {
        const response = _.get(result, 'data', {})

        // TurnOver
        if(!response.turnOvers.length) {
          this.chartDataTurnOver = {}
        } else {
          const seriesTurnOver = []
          const labelsTurnOver = []
          const noteTurnOver = []
          response.turnOvers.map(e => {
            if(e.value != 0) {
              seriesTurnOver.push({
                meta: e.text,
                value: parseFloat(e.value)
              })
              noteTurnOver.push(`Doanh thu thanh toán ${e.text}`)
              labelsTurnOver.push(parseFloat(e.value) + '%')
            }
          })

          this.chartDataTurnOver = {
            series: seriesTurnOver,
            labels: labelsTurnOver,
            note: noteTurnOver,
            color: colorChart
          }
        }


        // Quantities
        if(!response.quantities.length) {
          this.chartDataQty = {}
        } else {
          const seriesQty = []
          const labelsQty = []
          const noteQty = []
          response.quantities.map(e => {
            if(e.value != 0) {
              seriesQty.push({
                meta: e.text,
                value: parseFloat(e.value)
              })
              noteQty.push(`Số đơn thanh toán ${e.text}`)
              labelsQty.push(parseFloat(e.value) + '%')
            }
          })

          this.chartDataQty = {
            series: seriesQty,
            labels: labelsQty,
            note: noteQty,
            color: colorChart
          }
        }

      }
    }
  },
}
</script>

